import { useAccDetContact } from "../../api/account/useAccDetContact";
import { useState } from "react";
import AddContacts from "./AddContacts.tsx";
import ContactsShowDetail from "./ContactsShowDetail.tsx";

const ContactsTab = ({leadID, accountOwner, canViewLead}) => {
    const {contactData, error, isLoading, refetch} = useAccDetContact({leadID});
    const [showModal, setShowModal] = useState(false);
    const [selectedContactModal, setSelectedContactModal] = useState(false);
    const [selectedContactIndex, setSelectedContactIndex] = useState(null);
    
    const handleContactAdded = () => {
        refetch();
    };
    
    return(
        <>
        <div className="w-full flex flex-col shadow-lg p-4 md:p-6 bg-white rounded-2xl md:rounded-3xl item-start">
            <div className="flex flex-col sm:flex-row sm:justify-between w-full items-start sm:items-center gap-3">
                <h2 className="py-2 font-bold mb-4 text-base md:text-xl">Contacts</h2>
                {(accountOwner || canViewLead) && (
                    <button 
                    className="rounded-full border border-[#1E293B] px-4 py-2 text-sm md:text-base whitespace-nowrap min-h-[44px]"
                    onClick={() => setShowModal(true)}>
                        +  Add Contact
                    </button>
                )}
            </div>
            <div className="overflow-x-auto w-full">
            <table className="min-w-full bg-white border border-gray-200">
                <thead>
                    <tr className="bg-gray-100 border-none text-[#94A3B8]">
                        <th className="py-2 md:py-3 px-2 md:px-3 text-start text-sm md:text-lg whitespace-nowrap">Name</th>
                        <th className="py-2 md:py-3 px-2 md:px-3 text-start text-sm md:text-lg whitespace-nowrap">Designation</th>
                        <th className="py-2 md:py-3 px-2 md:px-3 text-start text-sm md:text-lg whitespace-nowrap">Email</th>
                        <th className="py-2 md:py-3 px-2 md:px-3 text-start text-sm md:text-lg whitespace-nowrap">Mobile Number</th>
                        <th className="py-2 md:py-3 px-2 md:px-3 text-start text-sm md:text-lg whitespace-nowrap">Reporting To</th>
                        <th className="py-2 md:py-3 px-2 md:px-3 text-center text-sm md:text-lg whitespace-nowrap">Last Edited At</th>
                        <th className="py-2 md:py-3 px-2 md:px-3 text-center text-sm md:text-lg whitespace-nowrap">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        [...Array(3)].map((_, index) => (
                            <tr key={index} className="border-gray-200 border text-[#212121]">
                            <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-sm"><div className="h-4 bg-gray-200 rounded animate-pulse"></div></td>
                            <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-sm"><div className="h-4 bg-gray-200 rounded animate-pulse"></div></td>
                            <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-sm"><div className="h-4 bg-gray-200 rounded animate-pulse"></div></td>
                            <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-sm"><div className="h-4 bg-gray-200 rounded animate-pulse"></div></td>
                            <td className="py-2 md:py-3 px-2 md:px-3 text-center text-xs md:text-sm"><div className="h-4 bg-gray-200 rounded animate-pulse"></div></td>
                            <td className="py-2 md:py-3 px-2 md:px-3 text-center text-xs md:text-sm"><div className="h-4 bg-gray-200 rounded animate-pulse"></div></td>
                        </tr>
                        ))
                    ) : contactData && contactData.length > 0 ? (
                        contactData.map((contact, index) => (
                            <tr key={index} className="border-gray-200 border text-[#212121] text-center">
                                <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-sm whitespace-nowrap">{contact.frontend_name  || '-'}</td>
                                <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-sm whitespace-nowrap">{contact.designation  || '-'}</td>
                                <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-sm whitespace-nowrap">{contact.email || '-'}</td>
                                <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-sm whitespace-nowrap">{contact.mobile_no || '-'}</td>
                                <td className="py-2 md:py-3 px-2 md:px-3 text-start text-xs md:text-sm whitespace-nowrap">{contact.reporting_to}</td>
                                <td className="py-2 md:py-3 px-2 md:px-3 text-center text-xs md:text-sm whitespace-nowrap">{contact.last_edited || '-'} </td>
                                <td className="py-2 md:py-3 px-2 md:px-3 text-xs md:text-sm cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedContactIndex(index);
                                        setSelectedContactModal(true);
                                    }}
                                        >
                                            <div className="flex justify-center items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 md:w-6 md:h-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z" />
                                            </svg>
                                            </div>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr className="border-gray-200 border text-[#212121]">
                            <td colSpan="7" className="py-2 md:py-3 px-2 md:px-3 text-center text-xs md:text-sm">No contacts available</td>
                        </tr>
                    )}
                </tbody>
            </table>
            </div>
        </div>
        <AddContacts 
            showModal={showModal}
            setShowModal={setShowModal}
            onContactAdded={handleContactAdded}
            leadID={leadID} />
        <ContactsShowDetail 
            selectedContactModal={selectedContactModal} 
            setSelectedContactModal={setSelectedContactModal} 
            contactData={selectedContactModal ? contactData[selectedContactIndex] : null}
            onContactUpdated={handleContactAdded}
            accountOwner={accountOwner}
            canViewLead={canViewLead}
        />
        </>
    )
}

export default ContactsTab;